import baseGoApi from './baseGoApi';
import { EducationPage, CreateEducationPageRequest, UpdateEducationPageRequest, EducationPageTree } from '@/types/Education';

// Get all education pages
export const getEducationPages = async (): Promise<EducationPage[]> => {
    const response = await baseGoApi.get('/education/pages');
    return response.data;
};

// Get education page tree structure
export const getEducationPageTree = async (): Promise<EducationPageTree> => {
    const response = await baseGoApi.get('/education/pages/tree');
    return response.data;
};

// Get education page by ID
export const getEducationPage = async (id: number): Promise<EducationPage> => {
    const response = await baseGoApi.get(`/education/pages/${id}`);
    return response.data;
};

// Get education page by slug
export const getEducationPageBySlug = async (slug: string): Promise<EducationPage> => {
    const response = await baseGoApi.get(`/education/slug/${slug}`);
    return response.data;
};

// Create new education page
export const createEducationPage = async (pageData: CreateEducationPageRequest): Promise<EducationPage> => {
    const response = await baseGoApi.post('/education/pages', pageData);
    return response.data;
};

// Update education page
export const updateEducationPage = async (id: number, pageData: UpdateEducationPageRequest): Promise<EducationPage> => {
    const response = await baseGoApi.put(`/education/pages/${id}`, pageData);
    return response.data;
};

// Delete education page
export const deleteEducationPage = async (id: number): Promise<void> => {
    await baseGoApi.delete(`/education/pages/${id}`);
};

// Reorder education pages
export const reorderEducationPages = async (pageIds: number[]): Promise<void> => {
    await baseGoApi.put('/education/pages/reorder', { pageIds });
};

// Move education page to different parent
export const moveEducationPage = async (pageId: number, newParentId: number | null, newOrder: number): Promise<void> => {
    await baseGoApi.put(`/education/pages/${pageId}/move`, { 
        parentId: newParentId, 
        order: newOrder 
    });
};
